import { formatCurrency, formatDate } from '@/shared/lib'

export type Props = {
  roomName: string
  startDate: string
  endDate: string
  finalPayFee: number
}

const DATE_FORMAT = 'yyyy년 MM월 dd일'

export const ContractInformation = ({
  roomName,
  startDate,
  endDate,
  finalPayFee,
}: Props) => {
  const formattedStartDate = formatDate({
    date: startDate,
    format: DATE_FORMAT,
  })
  const formattedEndDate = formatDate({
    date: endDate,
    format: DATE_FORMAT,
  })

  return (
    <div className="space-y-3 p-6 pt-0">
      <h3 className="typo-body1 text-start font-semibold text-black">
        계약 정보
      </h3>
      <div className="space-y-4">
        <div className="flex flex-col items-start gap-0.5">
          <p className="typo-label1 font-normal text-gray-500">방 이름</p>
          <p className="typo-label1 font-medium text-gray-900">{roomName}</p>
        </div>
        <div className="flex flex-col items-start gap-0.5">
          <p className="typo-label1 font-normal text-gray-500">계약기간</p>
          <p className="typo-label1 font-medium text-gray-900">
            {formattedStartDate} <span className="text-purple-500">(입주)</span>{' '}
            ~ {formattedEndDate} <span className="text-purple-500">(퇴실)</span>
          </p>
        </div>
        <div className="flex flex-col items-start gap-0.5">
          <p className="typo-label1 font-normal text-gray-500">결제금액</p>
          <p className="typo-body1 font-bold text-gray-900">
            {formatCurrency(finalPayFee)}원
          </p>
        </div>
      </div>
    </div>
  )
}
